// @ts-check
import React, { useRef, useState } from 'react';
import * as _ from 'lodash';

// pages
import { useGetDirectNoticeUnapprovedWorkSettingData } from '../../pages/ExternalServiceCooperation';

// components
import InUseContents from './DirectInUseContents';
import UnUseContents from './DirectUnUseContents';
import DirectRegisterBuildeeBotContents from './DirectRegisterBuildeeBotContents';
import DirectRegisterOrganizationContents from './DirectRegisterOrganizationContents';
import { Description } from '../Description';
import { DownloadFileErrorDialog } from '../modals/DownloadFileErrorDialog';

// utilities
import {
  DIRECT_STATUS_CODE,
  DIRECT_CORPORATION_MANUAL,
} from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';
import PrintUtility from '../../utilities/printUtility';

//images
// @ts-ignore 画像ファイルの型がない
import DirectLogo from '../../images/direct_icon.png';

// icons
import { OutputIcon } from '../icons/OutputIcon';

/**
 * @description directの説明自体を見せるか否か
 * @function
 * @param {string} status_code directのステータスコード
 */
function isShowDirectDescription(status_code) {
  return _.includes(
    [
      DIRECT_STATUS_CODE.INUSE,
      DIRECT_STATUS_CODE.UNUSE,
      DIRECT_STATUS_CODE.INVITING_BUILDEE_BOT,
      DIRECT_STATUS_CODE.CHOICE_DIRECT_ORGANIZATION,
      DIRECT_STATUS_CODE.APPROVAL_BUILDEE_BOT,
    ],
    status_code
  );
}

/**
 * @description コンテンツ部分で表示するコンポーネント
 * @function
 * @param {string} status_code directのステータスコード
 * @return {import("react").ReactChild | null} 表示するコンポーネント
 */
function showContents(status_code) {
  switch (status_code) {
    case DIRECT_STATUS_CODE.INUSE:
      return <InUseContents />;
    case DIRECT_STATUS_CODE.UNUSE:
      return <UnUseContents />;
    case DIRECT_STATUS_CODE.CHOICE_DIRECT_ORGANIZATION:
      return <DirectRegisterOrganizationContents />;
    case DIRECT_STATUS_CODE.INVITING_BUILDEE_BOT:
      return <DirectRegisterBuildeeBotContents />;
    default:
      return null;
  }
}

/**
 * @description 情報テキスト部分に表示するコンポーネント
 * @function
 * @param {string} status_code directのステータスコード
 * @return {import("react").ReactChild | null} 表示するコンポーネント
 */
function showInfoText(status_code) {
  switch (status_code) {
    case DIRECT_STATUS_CODE.INUSE:
      return messageUtility.getMessage('I-001-530');
    case DIRECT_STATUS_CODE.UNUSE:
      return messageUtility.getMessage('I-001-531');
    case DIRECT_STATUS_CODE.CHOICE_DIRECT_ORGANIZATION:
      return messageUtility.getMessage('I-001-532');
    case DIRECT_STATUS_CODE.INVITING_BUILDEE_BOT:
      return messageUtility.getMessage('I-001-533');
    case DIRECT_STATUS_CODE.APPROVAL_BUILDEE_BOT:
      return messageUtility.getMessage('I-001-534');
    default:
      return null;
  }
}

function showWarnText(status_code, noticeUnapprovedWorkSettingData) {
  switch (status_code) {
    case DIRECT_STATUS_CODE.INUSE:
      if (
        noticeUnapprovedWorkSettingData.isNoticeDisabled() &&
        noticeUnapprovedWorkSettingData.isConfigured()
      ) {
        return (
          <React.Fragment>
            <i className='i-warning' />
            {messageUtility.getMessage('E-001-452')}
          </React.Fragment>
        );
      } else {
        return null;
      }
    case DIRECT_STATUS_CODE.UNUSE:
    case DIRECT_STATUS_CODE.CHOICE_DIRECT_ORGANIZATION:
    case DIRECT_STATUS_CODE.INVITING_BUILDEE_BOT:
    case DIRECT_STATUS_CODE.APPROVAL_BUILDEE_BOT:
    default:
  }
}

export default function DirectDescription({ status_code }) {
  const [
    isShowDownloadFileErrorModal,
    SetIsShowDownloadFileErrorModal,
  ] = useState(false);
  const isRequestingFlag = useRef(false);
  const openManual = async () => {
    if (isRequestingFlag.current) {
      return;
    }
    isRequestingFlag.current = true;
    await PrintUtility.downloadStaticFilePDF(
      DIRECT_CORPORATION_MANUAL.fileCode,
      DIRECT_CORPORATION_MANUAL.fileName,
      SetIsShowDownloadFileErrorModal
    );
    isRequestingFlag.current = false;
  };

  const noticeUnapprovedWorkSettingData = useGetDirectNoticeUnapprovedWorkSettingData();
  return (
    <React.Fragment>
      {isShowDirectDescription(status_code) ? (
        <Description>
          <div className='ExternalServiceCooperation__service-name'>
            <img src={DirectLogo} height={72} />
            <div
              className='ExternalServiceCooperation__service-name--right'
              onClick={openManual}
            >
              <OutputIcon className='icon--2x' />
              <span className='ExternalServiceCooperation__manual-text'>
                マニュアル
              </span>
            </div>
          </div>
          <div className='ExternalServiceCooperation__contents'>
            {showContents(status_code)}
          </div>
          <div className='ExternalServiceCooperation__bar' />
          <div className='ExternalServiceCooperation__info-text'>
            {showInfoText(status_code)}
          </div>
          <div className='ExternalServiceCooperation__warn-text'>
            {showWarnText(status_code, noticeUnapprovedWorkSettingData)}
          </div>
        </Description>
      ) : null}
      <DownloadFileErrorDialog
        visible={isShowDownloadFileErrorModal}
        onClose={() => {
          SetIsShowDownloadFileErrorModal(false);
        }}
      />
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/externalService/DirectDescription.jsx